import React from 'react'
import { Dialog } from 'primereact/dialog'

import './ConfirmDialog.css'
import Btn from '../Btn/Btn'

function ConfirmDialog({
  title,
  isVisible,
  content,
  onOk,
  onCancelar,
  disabled = false,
  className = '',
  okLabel = 'OK',
  cancelLabel = 'CANCELAR',
}) {
  return (
    <div className={`ConfirmDialog ${className}`.trim()}>
      <Dialog header={title} visible={isVisible} modal={true} onHide={onCancelar}>
        <div style={{ marginTop: 10, marginBottom: 10 }}>{content}</div>
        <div className="p-grid">
          <div className="p-col-6 text-center">
            <Btn onClick={onCancelar}>{cancelLabel}</Btn>
          </div>
          <div className="p-col-6 text-center">
            <Btn onClick={onOk} disabled={disabled}>
              {okLabel}
            </Btn>
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default ConfirmDialog
